import React from 'react'
import { useFormikContext, ErrorMessage } from 'formik'
import { rationalNumbers } from 'Core/masks'

import { TextInputNew, Wrapper } from 'SRC/ui/FormElementsNew'

export const PriceMonthly = () => {
	const formik = useFormikContext()

	React.useEffect(() => {
		if (Number(formik.initialValues.priceMonthly) === -1) formik.setFieldValue('priceMonthly', '', false)

		return () => { formik.setFieldValue('priceMonthly', -1, false) }
	}, [])

	const error = formik.touched.priceMonthly && formik.errors.priceMonthly

	return (
		<Wrapper isError={error}>
			<TextInputNew
				id='priceMonthly'
				name='priceMonthly'
				title='Mjesečno'
				isRequired
				value={formik.values.priceMonthly}
				mask={rationalNumbers}
				measure='€'
				onChange={async textValue => {
					console.log('priceMonthly', textValue)
					formik.setFieldValue('priceMonthly', textValue, false)

					if (!formik.touched.priceMonthly) formik.setFieldTouched('priceMonthly', true)

					formik.setErrors({
						...formik.errors,
						priceMonthly: formik.touched.priceMonthly && [0, -1].includes(Number(textValue)) ? 'Popunite mjesečnu cijenu' : undefined
					})
				}}
			/>

			<ErrorMessage
				name='priceMonthly'
				render={msg => <span style={{ display: 'block', marginTop: 5 }} className='form-group__error-message'>{msg}</span>}
			/>
		</Wrapper>
	)
}

